<!-- ════════════════════════════════════════════════════════════════════════ -->
<!-- EXECUTIVE HEADER                                                         -->
<!-- ════════════════════════════════════════════════════════════════════════ -->
<div class="exec-header flex justify-between items-center flex-wrap gap-4">
    <div class="exec-header__left">
        <h1 class="exec-header__title">Panel de Asistencia</h1>
        <div class="exec-header__meta">
            <span class="exec-header__date">
                <mat-icon svgIcon="heroicons_solid:calendar-days" class="icon-size-4"></mat-icon>
                Corte al {{ today | date:'EEEE d \' de \'MMMM, yyyy' : '' : 'es' }}
            </span>
            <span class="exec-header__sep">·</span>
            <span class="exec-header__note">Datos en tiempo real</span>
        </div>
    </div>
    <div class="exec-header__right">
        <mat-form-field appearance="outline" class="fuse-mat-dense m-0">
            <mat-label>Rango de fechas</mat-label>
            <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="Inicio" (dateChange)="onDateRangeChange()">
                <input matEndDate formControlName="end" placeholder="Fin" (dateChange)="onDateRangeChange()">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>
</div>

<!-- ════════════════════════════════════════════════════════════════════════ -->
<!-- KPI STRIP                                                                -->
<!-- ════════════════════════════════════════════════════════════════════════ -->
<div class="kpi-strip">
    <div *ngFor="let kpi of kpis; let last = last"
         class="kpi-item"
         [class.kpi-item--last]="last">
        <div class="kpi-item__accent" [style.background]="kpi.accent"></div>
        <div class="kpi-item__icon" [style.color]="kpi.accent">
            <mat-icon [svgIcon]="kpi.icon" class="icon-size-5"></mat-icon>
        </div>
        <div class="kpi-item__body">
            <div class="kpi-item__label">{{ kpi.label }}</div>
            <div class="kpi-item__value">{{ kpi.value }}</div>
            <div class="kpi-item__delta">{{ kpi.delta }}</div>
        </div>
    </div>
</div>

<!-- ════════════════════════════════════════════════════════════════════════ -->
<!-- ROW 1: General + Por Nivel (lado a lado)                                 -->
<!-- ════════════════════════════════════════════════════════════════════════ -->
<div class="charts-row">

    <!-- General -->
    <div class="sig-card sig-card--sm">
        <div class="sig-card__head">
            <div class="sig-card__titles">
                <span class="sig-card__tag">Vista Global</span>
                <h2 class="sig-card__title">Resumen General</h2>
                <p class="sig-card__sub">Institución consolidada · valores en %</p>
            </div>
            <app-series-toggle
                [series]="toggleSeries"
                [activeSeries]="activeGeneral"
                (activeSeriesChange)="activeGeneral = $event">
            </app-series-toggle>
        </div>
        <div class="sig-card__body">
            <app-chart-horizontal-bar
                [categories]="chartGeneral.categories"
                [series]="chartGeneral.series"
                [activeSeries]="activeGeneral">
            </app-chart-horizontal-bar>
        </div>
    </div>

    <!-- Por Nivel -->
    <div class="sig-card sig-card--md">
        <div class="sig-card__head">
            <div class="sig-card__titles">
                <span class="sig-card__tag">Comparativa</span>
                <h2 class="sig-card__title">Asistencia por Nivel</h2>
                <p class="sig-card__sub">Inicial · Primaria · Secundaria</p>
            </div>
            <app-series-toggle
                [series]="toggleSeries"
                [activeSeries]="activeNiveles"
                (activeSeriesChange)="activeNiveles = $event">
            </app-series-toggle>
        </div>
        <div class="sig-card__body">
            <app-chart-horizontal-bar
                [categories]="chartNiveles.categories"
                [series]="chartNiveles.series"
                [activeSeries]="activeNiveles">
            </app-chart-horizontal-bar>
        </div>
    </div>

</div>
<!-- ════════════════════════════════════════════════════════════════════════ -->
<!-- ROW 2: Tabs de Nivel + Ranking por Grado                                -->
<!-- ════════════════════════════════════════════════════════════════════════ -->
<div class="sig-card mb-4">
    <div class="sig-card__head">
        <div class="sig-card__titles">
            <span class="sig-card__tag">Ranking</span>
            <h2 class="sig-card__title">Comparativo por Grado</h2>
            <p class="sig-card__sub">
                Comparativa de asistencia agrupada por grado · valores en %
            </p>
        </div>
        <app-series-toggle
            [series]="toggleSeries"
            [activeSeries]="activeGradesTotals"
            (activeSeriesChange)="activeGradesTotals = $event">
        </app-series-toggle>
    </div>

    <!-- Nivel Tabs -->
    <div class="nivel-tabs">
        <button
            *ngFor="let tab of nivelTabs"
            class="nivel-tab"
            [class.nivel-tab--active]="activeNivelTab === tab.id"
            (click)="selectNivelTab(tab.id)">
            <mat-icon [svgIcon]="tab.icon" class="icon-size-4"></mat-icon>
            {{ tab.label }}
        </button>
    </div>

    <div class="sig-card__body">
        <app-chart-vertical-bar
            [categories]="chartGradesTotals.categories"
            [series]="chartGradesTotals.series"
            [activeSeries]="activeGradesTotals"
            [height]="260">
        </app-chart-vertical-bar>
    </div>
</div>

<div class="sig-section-header">
    <h2 class="sig-section-header__title">
        Desglose por Grado y Sección
        <span class="sig-section-header__badge">{{ activeNivelLabel }}</span>
    </h2>
    <div class="sig-section-header__line"></div>
</div>

<!-- Desglose por Grado: una fila por grado, ancho completo -->
<div class="grade-rows">
    <div *ngFor="let item of chartsByGrade" class="sig-card grade-row-card">
        <div class="sig-card__head sig-card__head--compact">
            <div class="sig-card__titles">
                <div class="flex items-center gap-2">
                    <span class="grade-badge">{{ item.group.ordinal }}</span>
                    <h2 class="sig-card__title">{{ item.group.grado }}</h2>
                </div>
                <p class="sig-card__sub">{{ item.group.secciones.length }} secciones</p>
            </div>
            <app-series-toggle
                [series]="toggleSeries"
                [activeSeries]="activeByGrade[item.group.grado]"
                (activeSeriesChange)="activeByGrade[item.group.grado] = $event">
            </app-series-toggle>
        </div>
        <div class="sig-card__body sig-card__body--compact overflow-x-auto">
            <div [style.min-width.px]="item.group.secciones.length * 70" class="min-w-full">
                <app-chart-vertical-bar
                    [categories]="item.data.categories"
                    [series]="item.data.series"
                    [activeSeries]="activeByGrade[item.group.grado]"
                    [height]="200">
                </app-chart-vertical-bar>
            </div>
        </div>
    </div>
</div>
